
export default {
    name: 'historique-ordonnance-lunettes',
    components: {},
    props: {
        historique: Object
    },
    data() {
        return {

        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {

    }
}